module.exports = __webpack_public_path__ + "img/performanceManagement3.6f359551.png";